<template>
  <div class="page-content-wrapper user-list-page"  v-check-permission="'list-user-payments'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <h4 class="mt-0 header-title">Pagos</h4>
              <p class="text-muted m-b-30 font-14">Desde aquí podras ver tus pagos.</p>

              <div class="table-rep-plugin">

                <div class="row">
                  <div class="col-md-12 mb-3">
                    <button class="btn btn-primary pull-right" @click="getUserPayments()"><i class="fa fa-refresh" aria-hidden="true"></i> Actualizar pagos</button>
                  </div>
                  <div class="col-md-12 mb-3">
                    <p><b>AVISO IMPORTANTE:</b></p>
                    <ul>
                      <li>Las cuotas bloqueadas se habilitarán automáticamente luego de que se realice el pago de las cuotas anteriores vencidas pendientes de pago.</li>
                      <li>Los descuentos se aplican en el ultimo paso del pago.</li>
                    </ul>
                  </div>
                </div>

                <div class="table-responsive b-0" data-pattern="priority-columns">

                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Código del pago</th>
                        <th>Descripción</th>
                        <th>Tipo</th>
                        <th>Monto</th>
                        <th>Estado</th>
                        <th>Creado el</th>
                        <th>Vencimiento</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="payment in payments" :key="payment._id">
                        <td>{{ payment._id }}</td>
                        <td><b>{{ payment.title }}</b> <small v-if="payment.description"><br>({{ payment.description }})</small></td>
                        <td>
                          <span class="badge badge-warning" v-if="payment.paymentType == 'fee'">Cuota</span>
                          <span class="badge badge-info" v-if="payment.paymentType == 'enrollment'">Matrícula</span>
                          <span class="badge badge-dark" v-if="payment.paymentType == 'custom'">Personalizado</span>
                        </td>
                        <td>${{ payment.amount }}</td>
                        <td>
                          <span class="badge badge-primary" v-if="payment.paymentStatus == 'pending'">Pendiente</span>
                          <span class="badge badge-success" v-if="payment.paymentStatus == 'approved'">Pagado</span>
                        </td>
                        <td>{{ payment.createdAt | moment("DD/MM/YYYY") }}</td>
                        <td>{{ payment.dueDate | moment("DD/MM/YYYY") }}</td>
                        <td class="pull-right">

                          <router-link
                            :to="{ name: 'pay-fee', params: { id: payment._id }}"
                            class="btn btn-sm btn-danger"
                            v-if="(payment.paymentStatus == 'rejected' ||
                            payment.paymentStatus == 'pending' ||
                            payment.paymentStatus == 'cancelled' ||
                            payment.paymentStatus == 'refunded'  ||
                            payment.paymentStatus == 'charged_back') &&
                            payment.paymentType == 'fee' &&
                            (firstDuePayment && payment._id == firstDuePayment._id)"
                          >Pagar</router-link>

                          <a class="btn btn-sm btn-outline-primary" disabled="disabled"  v-if="(payment.paymentStatus == 'rejected' ||
                            payment.paymentStatus == 'pending' ||
                            payment.paymentStatus == 'cancelled' ||
                            payment.paymentStatus == 'refunded'  ||
                            payment.paymentStatus == 'charged_back') &&
                            payment.paymentType == 'fee' &&
                            (firstDuePayment && payment._id != firstDuePayment._id)"
                          title="Podras pagar la cuota luego de que pagues las vencidas anteriores."><i class="fa fa-lock"></i> Bloqueado</a>


                          <!--router-link
                            :to="{ name: 'pay-tuition', params: { id: payment._id }}"
                            class="btn btn-sm btn-danger"
                            v-if="(payment.paymentStatus == 'rejected' ||
                            payment.paymentStatus == 'pending' ||
                            payment.paymentStatus == 'cancelled' ||
                            payment.paymentStatus == 'refunded'  ||
                            payment.paymentStatus == 'charged_back') && payment.paymentType == 'enrollment'"
                          >Pagar</router-link-->

                          <router-link
                            :to="{ name: 'pay-tuition', params: { id: payment._id }}"
                            class="btn btn-sm btn-danger"
                            v-if="(payment.paymentStatus == 'rejected' ||
                            payment.paymentStatus == 'pending' ||
                            payment.paymentStatus == 'cancelled' ||
                            payment.paymentStatus == 'refunded'  ||
                            payment.paymentStatus == 'charged_back') && payment.paymentType == 'custom'"
                          >Pagar</router-link>

                          <small v-if="payment.paymentStatus !== 'approved' && payment.paymentType == 'enrollment'">
                            Para pagar la matrícula debes comunicarte con Tesorería.
                          </small>

                        </td>
                      </tr>
                      <tr v-if="payments.length === 0">
                        <td colspan="8">Aun no se han creado pagos para ti.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- end col -->
      </div> <!-- end row -->

    </div><!-- container -->

  </div>
</template>


<script>
  export default {
    name: 'list-user-payments',

    created () {
      this.getUserPayments()
    },

    data () {
      return {
        firstDuePayment: null
      }
    },

    computed: {
      payments: function () {
        return this.$store.getters.getUserPayments
      },
      payment: function () {
        return this.$store.getters.getUserPayment
      }
    },

    methods: {

      getUserPayments () {
        this.$loader.loading();
        this.$store.dispatch('getUserPayments')
          .then((response) => {
            this.getFirstDuePayment();
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },


      getFirstDuePayment () {
        //Obtenemos el pago vencido mas viejo
        var self = this;
        self.payments.forEach(function (element, index, array) {
          if(element.paymentStatus == 'pending' && element.paymentType == 'fee') {
            if(!self.firstDuePayment) {
              self.firstDuePayment = element;
            } else if (self.firstDuePayment.dueDate >= element.dueDate) {
              self.firstDuePayment = element;
            }
          }
        });
      },


      setPayment (payment) {
        this.$store.dispatch('setPayment', { payment : payment })
      }
    }
  }
</script>

<style scoped>
  .btn-outline-primary,
  .btn-outline-primary i{
    color: #eb7475!important;
  }

  .btn-outline-primary:hover,
  .btn-outline-primary:hover i{
    color: #fff!important;
  }
</style>



// WEBPACK FOOTER //
// src/screens/UserPaymentList.vue